import {Button} from '@wandb/weave/components/Button';
import React, {useCallback} from 'react';

import {useWorkspaceDrawerContext} from '../../WorkspaceDrawerContextProvider';

export const CloseButton = () => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const onClose = useCallback(
    () => closeWorkspaceDrawer(),
    [closeWorkspaceDrawer]
  );

  return (
    <Button
      data-test="workspace-drawer-close-button"
      variant="ghost"
      icon="close"
      onClick={onClose}
    />
  );
};
